import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CaseRoutingModule } from './case-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CaseIndexComponent } from './case-index/case-index.component';
import { NgbNavModule, NgbDatepickerModule, NgbDropdownModule, NgbTooltipModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { ComponentsModule as SharedComponentsModule } from 'src/app/shared/components/components.module';
import { AccountTransactionListModule } from '../../components/account-transactions/account-transaction-list/account-transaction-list.module';
import { CaseCreateModalModule } from '../../components/cases/case-create-modal/case-create-modal.module';
import { CaseCountingComponent } from './case-counting/case-counting.component';
import { UnitCostsComponent } from './unit-costs/unit-costs.component';
import { UnitCostDetailComponent } from './unit-cost-detail/unit-cost-detail.component';
import { PosTerminalComponent } from './pos-terminal/pos-terminal.component';
import { PosDevicesComponent } from './pos-devices/pos-devices.component';
import { PosIntegrationSettingsComponent } from './pos-devices/pos-integration-settings/pos-integration-settings.component';
import { PosTransactionsComponent } from './pos-transactions/pos-transactions.component';
import { PosJsonViewComponent } from './pos-transactions/pos-json-view/pos-json-view.component';
import { PosAmountCompareComponent } from './pos-transactions/pos-amount-compare/pos-amount-compare.component';
import { PosVoidModalComponent } from './pos-transactions/pos-void-modal/pos-void-modal.component';
import { PosRefundModalComponent } from './pos-transactions/pos-refund-modal/pos-refund-modal.component';
import { KeyToSubTypePipe } from 'src/app/shared/pipes/key-to-sub-type.pipe';
import { SortHeaderModule } from '../accounting/shared/sort-header/sort-header.module';
import { CoreModule } from 'src/app/core/core.module';
import { CaseTransferModalModule } from '../../components/cases/case-transfer-modal/case-transfer-modal.module';
import { CaseEditModalComponent } from '../../components/cases/case-edit-modal/case-edit-modal.component';
import { CaseEditModalModule } from '../../components/cases/case-edit-modal/case-edit-modal.module';
import { CaseDetailPanelModule } from '../../components/cases/case-detail-panel/case-detail-panel.module';


@NgModule({
  declarations: [
    CaseIndexComponent,
    CaseCountingComponent,
    UnitCostsComponent,
    UnitCostDetailComponent,
    PosTerminalComponent,
    PosDevicesComponent,
    PosIntegrationSettingsComponent,
    PosTransactionsComponent,
    PosJsonViewComponent,
    PosAmountCompareComponent,
    PosVoidModalComponent,
    PosRefundModalComponent,
  ],
  imports: [
    CommonModule,
    CaseRoutingModule,
    NgbNavModule,
    NgbDatepickerModule,
    NgbDropdownModule,
    NgbTooltipModule,
    NgbModalModule,
    PipesModule,
    FormsModule,
    CoreModule,
    SharedComponentsModule,
    AccountTransactionListModule,
    CaseCreateModalModule,
    CaseEditModalModule,
    CaseTransferModalModule,
    CaseDetailPanelModule,
    SortHeaderModule
  ],
  exports: [],
  providers: [KeyToSubTypePipe]
})
export class CaseModule { CaseCreateComponent }
